/** @format */

import {setAnalyticsCollectionEnabled,setUserId} from 'firebase/analytics'
import React,{useContext,useEffect,useState,useRef} from 'react'
import {Outlet,useNavigate} from 'react-router-dom'
import UserContext from '../contexts/UserContext'
import Loading from '../pages/Loading'
import analytics from '../helpers/analytics'
import useAnalyticsConsent from '../hooks/useAnalyticsConsent'
import TawkMessengerReact from '@tawk.to/tawk-messenger-react'

export default function Authenticated({children,...props}) {
  let navigate=useNavigate()
  const [user,loading,error]=useContext(UserContext)

  useEffect(() => {
    if(!user&&!loading) {
      const pathname=window.location.pathname
      navigate('/login/'+encodeURIComponent(pathname))
    }
    if(error) {
      navigate('/error')
    }
    if(user) {
      setUserId(analytics,user?.uid)
    }
  },[user,loading,navigate,error])

  if(loading||!user) {
    return <Loading />
  }

  return (
    <div className="overflow-x-hidden p-0 pb-8 m-0 w-full min-h-screen lg:pb-0">
      <Outlet />
    </div>
  )
}
